import { PagePerformanceLifecycle } from '@/lib/page-performance/PagePerformanceLifecycle'

export class ListPagePerformanceLifecycle extends PagePerformanceLifecycle {
  constructor(routeKey: string) {
    super(`list:${routeKey}`, 'list')
  }

  markVisible(): void {
    this.setVisible()
  }

  markInteractive(): void {
    this.setInteractive()
  }
}
